import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_SIGNATURE_HEIGHT_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewSignatureInfo } from "../note-preview-types";

export interface ReportSignatureDetailProps {
  label: string;
  value: string;
}

/** One "Label: value" line under a signature, label bold. */
export const ReportSignatureDetail = ({
  label,
  value,
}: ReportSignatureDetailProps) => (
  <div>
    <span style={{ fontWeight: 700 }}>{`${label}: `}</span>
    {value}
  </div>
);

export interface ReportSignatureBlockProps {
  signature: NotePreviewSignatureInfo;
}

const ReportSignatureBlock = ({ signature }: ReportSignatureBlockProps) => (
  <div
    style={{
      marginTop: 28,
      fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
      color: NOTE_PREVIEW_TEXT_COLOR,
      breakInside: "avoid",
    }}
  >
    <div style={{ height: NOTE_PREVIEW_SIGNATURE_HEIGHT_PX }}>
      {signature.image && (
        <img
          src={signature.image}
          alt={signature.signerName}
          style={{ height: "100%", objectFit: "contain" }}
        />
      )}
    </div>
    <ReportSignatureDetail
      label={NOTE_PREVIEW_LABELS.name}
      value={signature.signerName}
    />
    <ReportSignatureDetail
      label={signature.signedAtLabel}
      value={signature.signedAt}
    />
  </div>
);

export default ReportSignatureBlock;
